/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".isSticky_dbbb5a69{position:fixed;-webkit-overflow-scrolling:touch;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}\n"}]);
export const isSticky = "isSticky_dbbb5a69";